export const CashierTerminals = {
  en: {
    'Cashier Terminals': 'Cashier terminals',
    'Create Cashier Terminal': 'Create cashier terminal',
    Location: 'Location',
    Cashier: 'Cashier',
    'MAC Address': 'MAC address',
    Model: 'Model',
    Bank: 'Bank',
    Protocol: 'Protocol',
    Port: 'Port',
    'Merchant ID': 'Merchant ID',
    Notes: 'Notes',
    'Invalid MAC address format':
      'Invalid MAC address format (AA:BB:CC:DD:EE:FF)',
    'Port must be between {{min}} and {{max}}':
      'Port must be a number between {{min}} and {{max}}',
    'Merchant ID is required for SSI JSON terminals':
      'Merchant ID is required for SSI JSON terminals',
  },
  uk: {
    'Cashier Terminals': 'Касові термінали',
    'Create Cashier Terminal': 'Створити касовий термінал',
    Location: 'Локація',
    Cashier: 'Касир',
    'MAC Address': 'MAC адреса',
    Model: 'Модель',
    Bank: 'Банк',
    Protocol: 'Протокол',
    Port: 'Порт',
    'Merchant ID': 'Ідентифікатор продавця',
    Notes: 'Нотатки',
    'Invalid MAC address format':
      'Невірний формат MAC адреси (AA:BB:CC:DD:EE:FF)',
    'Port must be between {{min}} and {{max}}':
      'Порт має бути числом від {{min}} до {{max}}',
    'Merchant ID is required for SSI JSON terminals':
      "Ідентифікатор продавця обов'язковий для терміналів SSI JSON",
  },
};

export const CashierTerminalForm = {
  en: {
    ...CashierTerminals.en,
    'Cashier Terminal': 'Cashier terminal',
    'New Cashier Terminal': 'New cashier terminal',
    'Edit Cashier Terminal': 'Edit cashier terminal',
    'Update Cashier Terminal': 'Update cashier terminal',
  },
  uk: {
    ...CashierTerminals.uk,
    'Cashier Terminal': 'Касовий термінал',
    'New Cashier Terminal': 'Новий касовий термінал',
    'Edit Cashier Terminal': 'Редагування касового терміналу',
    'Update Cashier Terminal': 'Оновити касовий термінал',
  },
};
